import { render } from "./LowPoly.vue?vue&type=template&id=617cdd3d"
import script from "./LowPoly.vue?vue&type=script&lang=js"
export * from "./LowPoly.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__